/**
 * Copyright © Veeam Software Group GmbH.
 */

import { DurationColumn } from '@veeam-vspc/shared/components';
import React from 'react';

export const DurationColumnRender = ({ value }: { value: number; }) =>
    <DurationColumn value={value} />;
